import { observer } from "mobx-react";
import casino from "../assets/casino.png";
import myStore from "../mobX/Store";
import { useMediaQuery } from "react-responsive";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { toJS } from "mobx";

const Intro = observer(() => {
  const curDate = new Date();
  const fullYear = curDate.getFullYear();
  const isDesktop = useMediaQuery({ query: "(min-width: 1024px)" });
  const location = useLocation();
  const [page, setPage] = useState(null);

  const headlineInfo = {
    homePage: {
      title: "Check Out the Best UK Casino Sites of {curDate}",
      p: "Top UK real money online casinos compared and reviewed. Check the list of the most popular British online casinos. Play safely & responsibly",
    },
    top_table_games: {
      title: "Explore the Top Table Games in the UK - {curDate}",
    },
    live_roulette: {
      title: "Experience the Best Live Roulette in the UK - {curDate}",
    },
    gates_of_olympus: {
      title: "Gates of Olympus - Our Top Slot Pick in the UK for {curDate}",
      list: [
        "🎣 Top-Rated Gameplay: Join the angler in this high-volatility slot packed with free spins, cash-collect features, and fishing-themed fun.",
        "💸 High Win Potential: With a max win of 2,100x your stake and an engaging bonus round, every spin can bring a thrilling catch.",
        "🔒 Safe & Secure: Enjoy Gates of Olympus on trusted UK casino platforms licensed for fair, responsible, and secure play.",
      ],
    },

    blackjack: {
      title: "Blackjack: The Strategic Icon of UK Casinos - {curDate}",
      list: [
        "🃏 A Game of Legacy: From smoky saloons to sleek online tables, blackjack has evolved through centuries while retaining its timeless appeal.",
        "🧠 Skill Meets Simplicity: With easy-to-learn rules and deep strategic layers, blackjack attracts both casual players and seasoned pros.",
        "🌐 The Future is Now: Live dealers, mobile gameplay, and VR features are redefining how UK players experience blackjack in 2025.",
      ],
    },
    cookie_consent_policy: {
      title: "Cookie Policy 18+",
    },
    terms_and_conditions: {
      title: "Terms and Conditions",
    },
    privacy_policy: {
      title: "Privacy Policy",
    },
    about_us: {
      title: "About Us",
    },
  };

  useEffect(() => {
    setPage(location.pathname.substring(1).replaceAll("-", "_"));
    // switch (location.pathname) {
    //   default:
    //     return setPage("");
    //   case "/top-table-games":
    //     setPage("topTableGames");
    //     break;
    //   case "/live-roulette":
    //     setPage("liveRoulette");
    //     break;
    //   case "/gates-of-olympus":
    //     setPage("gatesOfolympus");
    //     break;
    //   case "/blackjack":
    //     setPage("blackjack");
    //     break;
    //   case "/about-us":
    //     setPage("about");
    //     break;
    //   case "/cookie-consent-policy":
    //     setPage("cookie");
    //     break;
    //   case "/terms-and-conditions":
    //     setPage("terms");
    //     break;
    //   case "/privacy-policy":
    //     setPage("privacy");
    //     break;
    // }
  }, [location]);

  // useEffect(() => {
  //   console.log(page);
  // }, [page]);

  return (
    <div className="intro _mt-5 tit-n-des text-white px-3">
      {page ? (
        <div className="text-white">
          <div
            className={`d-flex align-items-center justify-content-${
              isDesktop ? "between" : "center"
            }`}
          >
            <h1 className="intro-title fw-bold w-75 px-2">
              <span className="bg-black-50 px-2 rounded-3 fs-1">
                {headlineInfo?.[page]?.title.replace(
                  "{curDate}",
                  `${curDate.toLocaleString("default", {
                    month: "long",
                  })} ${curDate.getFullYear()} `,
                )}
              </span>
            </h1>
            {isDesktop && (
              <div className="mt-5 pt-3">
                <img
                  className="cards"
                  alt="cards"
                  width={isDesktop ? 200 : 120}
                  src={casino}
                />
              </div>
            )}
          </div>
          {/* {headlineInfo[page].list && (
            <ul className="list-unstyled fw-bolder">
              {headlineInfo[page].list.map((li, i) => (
                <li className="mt-1 mb-1" key={i}>
                  {li}
                </li>
              ))}
            </ul>
          )} */}
        </div>
      ) : (
        <>
          {myStore.type.startsWith("bl") && (
            <div className="bg-black bg-opacity-75 pb-2">
              <p
                style={{ marginTop: 80 }}
                className="text-center text-white pb-0 mb-0 fs-2"
              >
                ADVERTORIAL
              </p>
              <aside className="fs-7 text-white lh-1 text-center w-100 sm-w-100 mx-auto">
                We receive advertising fees from the brands we review, which may
                influence our rankings and scores. We do not compare every
                service provider on the market Advertiser Disclosure 18+."T&C"
                apply - the applicable operator's terms apply for each offer
                below and free offers may include additional terms.
              </aside>
            </div>
          )}
          <div
            className={`d-flex align-items-center justify-content-${
              isDesktop ? "between" : "center"
            }`}
          >
            <div>
              <h1 className={`intro-title fw-bold w-${isDesktop ? 75 : 100}`}>
                {myStore.type === "blanca" ? (
                  <span className="bg-black bg-opacity-75">
                    Check Out the Best UK Casino Sites of{" "}
                    {curDate.toLocaleString("default", { month: "long" })}{" "}
                    {fullYear}
                  </span>
                ) : (
                  toJS(myStore.content).firstTitle.replace(
                    "{curDate}",
                    `${curDate.toLocaleString("default", {
                      month: "long",
                    })} ${curDate.getFullYear()} `,
                  )
                )}
              </h1>
            </div>
            {isDesktop && (
              <div>
                <img
                  className="cards"
                  alt="cards"
                  width={isDesktop ? 200 : 120}
                  src={casino}
                />
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
});

export default Intro;
